module.exports = __webpack_public_path__ + "media/images/icon_list/chart-69b4c9c8829bb319b1085ba53e761dfc.svg";